module.exports = __webpack_public_path__ + "html/toast-wrap.template.html";